import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../redux/axios';

const initialState = {
    AllProcessData: [],
    processCount: 0,
    isFetching: false,
    isAllProcessSuccess: false,
    isError: false,
    errorMessage: '',
};

export const getAllProcess = createAsyncThunk(
    'clerk/allProcess',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/clerk/loadKiv?limit=10&page=${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);



export const SearchAllProcess = (sdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let response = await axios({
            url: `/api/clerk/loadKiv?${sdata}`,
            method: 'get',
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        });

        let data = response.data;
        if (response.status === 200) {
            return data;
        }
        else if (data.code === 200) {
            return data;
        }
        else {
            return [];
        }
    } catch (err) {
        if (!err.response) {
            throw err
        }

    }
};






export const ClerkAllProcessSlice = createSlice({
    name: 'clerkAllProcess',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearStateAllProcess: (state, { payload }) => {
            state.AllProcessData = [];
            // state.isFetching = false;
            state.isAllProcessSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getAllProcess.fulfilled]: (state, { payload }) => {

            state.AllProcessData = payload.data;
            state.processCount = payload.data.count;
            state.isFetching = false;
            state.isAllProcessSuccess = true;
            return state;
        },
        [getAllProcess.pending]: (state) => {
            state.isFetching = false;
        },
        [getAllProcess.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const DeleteProcessAsyn = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/clerk/delKiv', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });
  
    let data = response.data;
    console.log(data.data)
    // dispatch(setAddState(data));
    return data;
  };

export const { clearStateAllProcess } = ClerkAllProcessSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateAllProcess());
    }
}

export const clerkAllProcessSelector = (state) => state.clerkAllProcess;

export default ClerkAllProcessSlice.reducer;
